// extracted by mini-css-extract-plugin
export default {"logoutButton":"LogoutButton_logoutButton__Pjo9s","logoutIcon":"LogoutButton_logoutIcon__LLhVp"};